import { render, staticRenderFns } from "./question-09.vue?vue&type=template&id=1598b0c1&scoped=true&lang=pug"
var script = {}
import style0 from "./question-09.vue?vue&type=style&index=0&id=1598b0c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1598b0c1",
  null
  
)

export default component.exports